<script>
export default {
    props: {
        type: {
            type: String,
            default: 'primary',
        },
        disabled: Boolean,
        submit: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        className() {
            return ['Button', this.type];
        },
        buttonType() {
            return this.submit ? 'submit' : 'button';
        },
    },
};
</script>

<template>
    <button :class="className" :disabled="disabled" :type="buttonType">
        <div class="ButtonInner">
            <slot></slot>
        </div>
    </button>
</template>

<style lang="stylus" scoped>
@import '../../stylus/vars.styl'

.Button
    display inline-flex
    align-items center
    justify-content center
    padding 2px
    border-radius 30px
    text-decoration none
    transition .3s all
    overflow hidden
    white-space nowrap
    border none
    font-size 15px
    line-height 20px
    cursor pointer
    outline 0
    -webkit-appearance: none;
    -moz-appearance: none;
    .ButtonInner
        display inline-flex
        align-items center
        justify-content center
        border-radius 30px
        padding 18px 48px
        outline 0
        background #ededed
        font-size 1em
        font-weight 700
        color #181834
        transition .3s all
        overflow hidden
    &.primary
        background linear-gradient(to right, #2FFAE6, #544FFF)
    &.secondary
        background #E1E1E1
    &.semibig
        font-size 20px
    &.altpadding
        .ButtonInner
            padding 15.5px 63px
    &.big
        font-size 25px
    &.noborder
        background white
        box-shadow 0 40px 100px rgba(0,0,0,.2)
    &.icon
        border-radius 50%
        .ButtonInner
            padding 2px
            width 54px
            height 54px
    &.clear
        background transparent
        .ButtonInner
            background transparent
    &.white
        .ButtonInner
            background white
    &:hover:not(:disabled)
        padding 4px
        &.icon .ButtonInner
            padding 0
        &:not(.icon) .ButtonInner
            padding 16px 46px
        &.altpadding .ButtonInner
                padding 13.5px 61px
    &:disabled:not(.clear)
        background $cBorder
    &:disabled
        cursor not-allowed
        .ButtonInner
            color $cBorder
    .ml
        margin-left 16px
    .mr
        margin-right 16px

</style>


